import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["text", "hint", 'toCopy'];

  // @todo hier muss noch der Creator Code mit dem richtigen Link bereitgestellt werden und ein Hinweis ausgespielt werden.
  copy() {
    const toCopy = this.textTarget.dataset.toCopy

    navigator.clipboard
      .writeText(toCopy)
      .then(() => {
        this.showHint();
      })
      .catch((err) => {
        console.error("Fehler beim Kopieren:", err);
      });
  }

  showHint() {
    this.hintTarget.style.display = "block";

    // Hinweis nach 2 Sekunden wieder ausblenden
    setTimeout(() => {
      this.hintTarget.style.display = "none";
    }, 1000);
  }
}
